// extracted by mini-css-extract-plugin
export default {"notificationButtonMessage":"Zd3X7"};